import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Panel } from '../../../../components/Layout/Panel';
import {
  Screen,
  SplitScreen,
  SplitScreenContentHolder
} from '../../../../components/Layout/Screen';
import Title, { Highlight, Subtext } from '../../../../components/Title';
import { DiagonalLine, HorizontalLine, VerticalLine } from '../../../../components/Layout/Line';
import { BackgroundContainer } from '../../../../components/Layout/AbsolutePositioned';
import GifViewer from '../../../../components/GifViewer';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import scrollingGIF from '../../../../assets/images/pages/patient-hope/scrolling.gif';
import scrollingPNG from '../../../../assets/images/pages/patient-hope/scroll-info.png';
import tappingGIF from '../../../../assets/images/pages/patient-hope/tapping.gif';
import tappingPNG from '../../../../assets/images/pages/patient-hope/touch-info.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: ${brandColors.yellow};
  padding-top: 1px;
  margin-top: -1px;

  .title {
    padding: 10px;
    @media ${device.mobileL} {
      padding: 20px;
    }
    @media ${device.tablet} {
      padding: 30px;
    }
    @media ${device.laptop} {
      padding: 20px;
    }

    h2 {
      max-width: 100%;
      font-size: 30px;
      line-height: 30px;
      @media ${device.tablet} {
        font-size: 36px;
        line-height: 42px;
      }
    }

    .subtext {
      max-width: 453px;
      font-size: 16px;
      line-height: 36px;
    }
  }
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

const StyledPanel = Panel.extend`
  border-top: 1px solid rgba(128, 128, 128, 0.25);
  width: 100%;
  height: 40%;
  @media ${device.tablet} {
    width: 50%;
    height: 50%;
  }
`;

const ImgBoxes = styled.div`
  width: 100%;

  @media ${device.tablet} {
    width: 45%;
  }
`;

const ImgBox = styled.div`
  width: 100%;
  margin: 3px auto;
  max-width: 361px;

  @media ${device.tablet} {
    width: 100%;
    max-width: 100%;
    margin: 17px auto;
  }
`;

const HowWeDidItScreen = () => (
  <StyledScreen>
    <BackgroundContainer>
      <HorizontalLine />
      <VerticalLine />
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
    </BackgroundContainer>
    <ContentContainer>
      <StyledPanel top="unset" left="unset" right="0" bottom="0">
        <Title primary={false} className="title">
          How we <Highlight>did</Highlight> it
          <br />
          <Subtext className="subtext">
            Whilst the client had in mind a particular way eLearning might look, we were able to
            convince them otherwise. We persuaded them that a scrolling page approach would achieve
            a much more modern user experience and that the possibilities in terms of interactivity
            and engagement were far beyond what they had imagined.
          </Subtext>
        </Title>
      </StyledPanel>
      <ImgBoxes>
        <ImgBox>
          <GifViewer
            imgSrc={scrollingPNG}
            title="Scrolling outperforming pagination"
            gifSrc={scrollingGIF}
          />
        </ImgBox>
        <ImgBox>
          <GifViewer
            imgSrc={tappingPNG}
            title="Touch screens make scrolling inherently easier"
            gifSrc={tappingGIF}
          />
        </ImgBox>
      </ImgBoxes>
    </ContentContainer>
  </StyledScreen>
);

export default connect()(HowWeDidItScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/AdvocatingForPatientsHope/screens/HowWeDidIt.jsx